import { styled } from 'baseui';
export const ModalBody = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.sizing.scale600
}));
export const ModalFooter = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: $theme.sizing.scale600
}));